module.exports = __webpack_public_path__ + "media/images/plans/wedding_reception/ex-natural-30e356ab00225e8a5762ccaa2d549f72.png";